
import {createSlice} from "@reduxjs/toolkit";

export const viewershipSlice = createSlice({
    name: 'viewershipSlc',
    initialState: {value: {id: null, externalId: null, productId: null, platformId: null,
            viewDate: null, views: null, viewedMinutes: null, rating: null, source: null,
            status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            platformCode: null, platformName: null,
            service: null, platformTerritory: null, usageMarket: null, platformOwner: null,
            propertyName: null, initialMarket: null, genre: null, productionType: null,
            viewershipDrawerState: false, viewershipDrawerMode: null, viewershipGridRefresh: false
        }},
    reducers:

{
    changeViewership: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeViewership } = viewershipSlice.actions;

export default  viewershipSlice.reducer ;
